import {SurveyFieldProblem} from "../shared/surveyAnswerValidation.util";
import {PublicSurveyErrorCode, PublicSurveyValidationError} from "./publicSurvey.api";

export const problemFromServerError = (error: PublicSurveyValidationError): SurveyFieldProblem => {
    switch (error.code) {
        case PublicSurveyErrorCode.REQUIRED:
            return {key: 'Please answer this question'};
        case PublicSurveyErrorCode.CONSENT_REQUIRED:
            return {key: 'Please accept to continue'};
        case PublicSurveyErrorCode.SIGNATURE_REQUIRED:
            return {key: 'Please sign to continue'};
        case PublicSurveyErrorCode.CHECKLIST_INCOMPLETE:
            return {key: 'Please confirm every item'};
        case PublicSurveyErrorCode.INVALID_EMAIL:
            return {key: 'Please enter a valid email address'};
        case PublicSurveyErrorCode.OUT_OF_RANGE:
        case PublicSurveyErrorCode.INVALID_OPTION:
        case PublicSurveyErrorCode.CUSTOM_TEXT_NOT_ALLOWED:
            return {key: 'Please check this answer'};
        default:
            return {key: error.message};
    }
};
